import styled, { css } from 'styled-components';

import VdpBox from '../../../_shared/components/VdpBox';
import Box from '../../../_shared/components/Box';
import Detail from '../../../_shared/components/Detail';
import Icon from '../../../_shared/components/Icon';
import applyResponsiveVdpStyles from '../../../_shared/helpers/applyResponsiveVdpStyles';

/**
 * Variant Definitions
 */
const StyledSellerInfoVariants = {
  expanded: css`
    width: 49%;
    padding: 36px;
  `
};

const StyledSellerHeadingVariants = {
  mini: css`
    margin-bottom: 24px !important;
  `
};

const StyledBoxVariants = {
  expanded: css`
    margin-top: 44px;
    flex-direction: row;
  `
};

const StyledQABoxVariants = {
  mini: css`
    margin-right: 10px;
  `,
  expanded: css`
    margin-right: 36px;
  `
};

const StyledPaymentBoxVariants = {
  mini: css`
    margin-right: 10px;
  `
};

/**
 * Styled Components
 */
export const StyledDealerLoading = styled.div`
  div {
    margin-bottom: 13px;
  }
`;

export const StyledSellerInfo = styled(VdpBox)`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      expanded: StyledSellerInfoVariants.expanded
    })}
`;

export const StyledSellerHeading = styled.h2`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: end;
  max-height: 24px;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledSellerHeadingVariants.mini,
      expanded: StyledSellerHeadingVariants.expanded
    })}
`;

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      expanded: StyledBoxVariants.expanded
    })}
`;

export const StyledSellerSubHeading = styled(Detail.Label)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding: 0;
  margin-bottom: 9px;
  margin-right: 6px;
`;

export const StyledDealerBox = styled(Box)`
  width: 50%;
  margin-right: 25px;
  flex-direction: column;
`;

export const StyledQABox = styled(Box)`
  max-width: 50%;
  flex-direction: column;

  p {
    margin: 0;
    margin-bottom: 13px;
  }

  button {
    background: ${({ theme }) => theme.COLORS.TRANSPARENT};
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    border-color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

    a {
      text-decoration: none;
      color: inherit;
    }
  }

  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledQABoxVariants.mini,
      expanded: StyledQABoxVariants.expanded
    })}
`;

export const StyledDealer = styled.div`
  a,
  span {
    display: block;
    word-break: break-word;
  }
`;

export const StyledRatings = styled.div`
  margin: 13px 0 6px 0;
  display: flex;
  align-items: center;

  svg {
    margin-left: 6px;
  }
`;

export const StyledNoRatings = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  margin-top: 9px;
`;

export const StyledRatingsCount = styled(Detail.Label)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  padding: 0;
  margin-left: 9px;
`;

export const StyledIcon = styled(Icon)`
  height: 18px;
  width: 18px;
`;

export const StyledNetworkBox = styled(Box)`
  flex-direction: row;
  align-items: baseline;

  div:nth-child(2) {
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }
`;

export const StyledPaymentBox = styled(Box)`
  flex-direction: column;
  margin-top: 13px;
  margin-left: auto;

  p {
    margin: 0;
  }

  ${({ theme }) =>
    applyResponsiveVdpStyles(theme, {
      mini: StyledPaymentBoxVariants.mini
    })}
`;

export const StyledNetworkName = styled.span`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  justify-content: flex-start;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 160px;
`;

export const StyledIconContainer = styled.div`
  width: 18px;
  margin-right: 6px;
  svg {
    height: 18px;
    width: 18px;
  }
`;

export const StyledDealerInfo = styled.div``;
